"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'project.name.placeholder': 'Introducir nombre del proyecto',
};
